import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import Breadcrumb from '../../../components/common/breadcrumb';
import DataTables from '../commonComponent/DataTable/DataTables';
import { URL_Start } from '../../../constant';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Modal, Spinner } from 'react-bootstrap';
import ToolTip from '../commonComponent/ToolTip';
import { useHistory } from "react-router-dom";


var glbRecords = [];
const Promotions = () => {
    const [tableData, setTableData] = useState([]);
    const [crntPageNO, setCrntPageNO] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [crntPageNO2, setCrntPageNO2] = useState(0);
    const [searchQueryCentres, setSearchQueryCentres] = useState("");
    const [selectedCentreList, setSelectedCentreList] = useState([]);
    const [showItemsModal, setShowItemsModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selecteditems, setSelecteditems] = useState([]);
    const [crntPageNO4, setCrntPageNO4] = useState(0);
    const history = useHistory();
    let textSearch = useRef();
    useEffect(() => { BindGrid(); }, []);
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <div>
                <span>{crntPageNO + rowIndex + 1}</span>
            </div>
        </React.Fragment>
    }
    const actionFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <div>
                <ToolTip title="Edit" placement="top" onClick={() => HandleDetails(rowData.Id)} linkId="Edit" faName="fa fa-pencil mr-2"></ToolTip>
                <ToolTip title="View Centres" placement="top" onClick={() => handleButtonClick(rowData.Id)} linkId="Centre" faName="fa fa-info-circle mr-2"></ToolTip>
                <ToolTip title="View Items" placement="top" onClick={() => handleButtonClick2(rowData.Id)} linkId="Item" faName="fa fa-exclamation-circle mr-2"></ToolTip>
            </div>
        </React.Fragment>
    }
    const columns = [
        { dataField: '#', text: '#', editable: false, formatter: idFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } },
        { dataField: 'CouponName', text: 'Coupon Name', editable: false },
        { dataField: 'CouponDescription', text: 'Coupon Description', editable: false },
        { dataField: 'ApplicableFrom', text: 'Applicable From', editable: false },
        { dataField: 'ApplicableTo', text: 'Applicable To', editable: false },
        { dataField: 'IsActive', text: 'Is Active', editable: false },
        { dataField: '', text: 'Action', formatter: actionFormatter, editable: false, headerStyle: (colum, colIndex) => { return { width: '7%' }; } }
    ];

    const handleSearch = async () => {
        const searchValue = textSearch.current.value.toLowerCase();
        setCrntPageNO(0);
        setTableData(glbRecords.filter((item) => 
            item.CouponName.toLowerCase().indexOf(searchValue) !== -1 ||
            (item.CentreName && item.CentreName.toLowerCase().indexOf(searchValue) !== -1) ||
            (item.ItemName && item.ItemName.toLowerCase().indexOf(searchValue) !== -1)
        ));
    }
    const BindGrid = async () => {
        setIsLoading(true);
        let url = URL_Start + 'promotions/getpromotioncouponlist'
        await axios.get(url).then((response) => {
            const data = response.data;
            if (data.Success) {
                if (data.Data == null || data.Data == undefined || data.Data == "") { }
                else {
                    glbRecords = data.Data;
                    setTableData(glbRecords);
                }
                setIsLoading(false);
            }
            else {
                if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }); }
                else { SweetAlert.fire("Error is: " + data.Data); }
                setIsLoading(false);
            }
        }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
    }
    const paginationOptions = { sizePerPage: 50, showTotal: false, firstPageText: 'First', prePageText: 'Back', nextPageText: 'Next', lastPageText: 'Last', onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); } };
    const HandleDetails = async (id) => {
        localStorage.setItem('CouponId', id);
        history.push({ pathname: `${process.env.PUBLIC_URL}/master/addcoupon`, search: `` });
    }
    const handleShow = () => setShowModal(true);
    const handleButtonClick = (CouponId) => { GetEditPromotionData(CouponId, "1"); };
    const idFormatter2 = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <span>{crntPageNO2 + rowIndex + 1}</span>
        </React.Fragment>
    }
    const columns3 = [
        { dataField: "id", text: "Id", editable: false, formatter: idFormatter2 },
        { dataField: "name", text: "Centres", editable: false },
    ];
    const paginationOptions2 = {
        sizePerPage: 5,
        showTotal: false,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO2(((page - 1) * sizePerPage)); }
    };
    const tableDataCentres = selectedCentreList.map((item, index) => ({
        id: index,
        name: item.label,
        description: item.value
    }));
    const filteredTableDataCentres = tableDataCentres.filter((row) =>
        String(row.name).toLowerCase().includes(String(searchQueryCentres).toLowerCase())
    );
    const GetEditPromotionData = async (CouponId, flag) => {
        try {
            let url = URL_Start + 'promotions/geteditpromotiondata/' + CouponId
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data != null) {
                        const outputdata = data.Data;
                        if (flag == "1") {
                            setSelectedCentreList(outputdata.zcentre);
                            handleShow();
                        }
                        else if (flag == "2") {
                            setSelecteditems(outputdata.zitems);
                            handleItemsShow();
                        }
                    }
                    else { SweetAlert.fire("No data found"); }
                }
                else {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const handleItemsShow = () => setShowItemsModal(true);
    const handleButtonClick2 = (CouponId) => { GetEditPromotionData(CouponId, "2"); };
    const tD = selecteditems.map((item, index) => ({
        id: index,
        name: item.label,
        description: item.value
    }));
    const filteredData = tD.filter((row) =>
        String(row.name).toLowerCase().includes(String(searchQuery).toLowerCase())
    );
    const paginationOptions4 = {
        sizePerPage: 5,
        showTotal: false,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO4(((page - 1) * sizePerPage)); }
    };
    const idFormatter4 = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <span>{crntPageNO4 + rowIndex + 1}</span>
        </React.Fragment>
    }
    const columns4 = [
        { dataField: "id", text: "Id", editable: false, formatter: idFormatter4 },
        { dataField: "name", text: "Items", editable: false },
    ];
    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400") { SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" }); }
        else if (ErrorCode == "401") { SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" }); }
        else if (ErrorCode == "403") { SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" }); }
        else if (ErrorCode == "404") { SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" }); }
        else if (ErrorCode == "500") { SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" }); }
        else if (ErrorCode == "503") { SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" }); }
    }
    return (
        <React.Fragment>
            <Breadcrumb title="Promotions" parent="Masters" />
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form.Row className="justify-content-center">
                                    <Col lg={6} md={6} sm={6} col={6} className="col-5">
                                        <Form.Group>
                                            <InputGroup className="mb-3">
                                                <Form.Control onChange={handleSearch} placeholder="Search by coupon name OR centre name OR item name..." ref={textSearch} />
                                                <InputGroup.Append>
                                                    <Button variant="secondary" onClick={handleSearch}><i className='fa fa-search'></i></Button>
                                                </InputGroup.Append>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2} md={6} sm={6} col={6} className="col-7">
                                        <Form.Group>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Append>
                                                    <Button variant='primary' type='submit' onClick={() => HandleDetails('0')}>Add Coupon </Button>
                                                </InputGroup.Append>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Header className='pb-0'>
                                <Card.Title>Coupon List</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {
                                    isLoading ?
                                        <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                                        <>
                                            <DataTables keyField='Id' tableData={tableData} columns={columns} pagination={paginationFactory(paginationOptions)} />
                                        </>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" >
                    <Modal.Header closeButton>
                        <Modal.Title>View Centres</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedCentreList.length > 0 ? (
                            <div className="container mt-3">
                                <InputGroup className="mb-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search centres..."
                                        value={searchQueryCentres}
                                        onChange={(e) => setSearchQueryCentres(e.target.value)}
                                    />
                                    <InputGroup.Append>
                                        <Button variant="secondary">
                                            <i className="fa fa-search"></i>
                                        </Button>
                                    </InputGroup.Append>
                                </InputGroup>
                                <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden", className: "table-striped", }}>
                                    <DataTables
                                        keyField="id"
                                        tableData={filteredTableDataCentres}
                                        columns={columns3}
                                        pagination={paginationFactory(paginationOptions2)}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <p>No Centres Selected.</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showItemsModal} onHide={() => setShowItemsModal(false)} size="lg" >
                    <Modal.Header closeButton>
                        <Modal.Title>View Items</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selecteditems.length > 0 ? (
                            <div className="container mt-3">
                                <InputGroup className="mb-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search items..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <InputGroup.Append>
                                        <Button variant="secondary">
                                            <i className="fa fa-search"></i>
                                        </Button>
                                    </InputGroup.Append>
                                </InputGroup>
                                <div
                                    style={{
                                        maxHeight: "400px",
                                        overflowY: "auto",
                                        overflowX: "hidden"
                                    }}
                                    className="table-striped"
                                >
                                </div>
                                <div className="mt-2">
                                    <DataTables
                                        keyField="id"
                                        tableData={filteredData}
                                        columns={columns4}
                                        pagination={paginationFactory(paginationOptions4)}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <p>No Items Selected.</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowItemsModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </React.Fragment>
    )
}

export default Promotions;